import styled from "../../../styled";

export const StyledWrap = styled.div`
  padding: 10px;
`;
